import React, { useCallback } from 'react';
import _ from 'lodash';
import moment from 'moment';
import appConfig from 'app-config';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLTooltipComponent } from 'ml-components-platform-react';
import { MLQuoteNameUtil } from 'ml-portals-util-js';
import { MLTagManagerService } from 'ml-portals-services-react'

import metadata from './MLClaimSummariesComponent.metadata.json5';
import messages from './MLClaimSummariesComponent.messages';
import styles from './MLClaimSummariesComponent.module.scss';

function MLClaimSummariesComponent(props) {
    const { claims, history } = props;
    const translator = useTranslator();

    const getPolicyType = useCallback((policyType) => {
        return MLQuoteNameUtil.getProductName(policyType);
    }, []);

    const shouldLinkBeDisabled = useCallback((claim) => {
        const TWO_HOURS = 60 * 60 * 1000 * 2;
        return new Date() - claim.reportedDate_ML >= TWO_HOURS;
    }, []);

    const navigateTo = useCallback((claim)=> {
        MLTagManagerService.sendLinkClickEvent(`Claims_${claim.lossCause_ML}`);
        if (_.get(appConfig, 'role.vendor')) {
            history.push(`/claims/${claim.claimNumber}`);
        } else if (claim.claimState !== 'draft') {
            history.push(`/claims/${claim.claimNumber}`);
        } else if (!shouldLinkBeDisabled(claim)) {
            history.push('/fnol', {claimNumber: claim.claimNumber});
        }
    }, [history, shouldLinkBeDisabled]);

    const generateClaimTableOverrides = useCallback(() => {
        const overrides = claims.map((claim, index) => {
            return {
                [`policyValue${index}`]: {
                    content: getPolicyType(claim.lineOfBusinessCode)
                },
                [`claimNumberValue${index}`]: {
                    content: claim.claimNumber,
                    /** REMOVE THIS BLOCK ONCE FNOL IS READY
                     *  START 
                     */
                    disabled: claim.claimState === 'draft',
                    /*
                     * END 
                     */
                    onClick: () => navigateTo(claim)
                },
                [`dateOfLossValue${index}`]: {
                    content: moment(claim.lossDate).format('MM/DD/YYYY')
                },
                [`statusMobileLabel${index}`]: {
                    content: (
                        <div className={styles.statusBlock}>
                            {translator(messages.status)}
                            <MLTooltipComponent tooltipContent={translator(messages.statusHelpMsg)} />
                        </div>
                    )
                },
                [`statusValue${index}`]: {
                    content: _.capitalize(claim.claimState)
                }
            }
        });
        return Object.assign({}, ...overrides);
    }, [claims, getPolicyType, navigateTo, translator]);

    const overrideProps = {
        status: {
            content: (
                <>
                    <div>{translator(messages.status)}</div>
                    <MLTooltipComponent tooltipContent={translator(messages.statusHelpMsg)} />
                </>
            )
        },
        claimSummaryTableRow: {
            data: _.orderBy(claims, 'lossDate_ML', 'asc')
        },
        ...generateClaimTableOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles
    }

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
}

MLClaimSummariesComponent.propTypes = {
    claims: PropTypes.shape({})
};

export default withRouter(MLClaimSummariesComponent);
